import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { DisclaimerPage } from '../disclaimer/disclaimer'; 
import { HomePage } from '../home/home'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { Auth } from '../../providers/auth';

@Component({
  selector: 'page-about',
  templateUrl: 'about.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class AboutPage {
  items = [
    'Italiano',
    'English'
  ];
  
  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public auth: Auth, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(this.functions.sidemenuEnabled, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(this.functions.sidemenuEnabled);
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }
  
  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

  goToDisclaimer(){
    this.navCtrl.push(DisclaimerPage, {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts